export default __webpack_public_path__ + "static/media/Eye_7_F_C5.6cbbe857.svg";